module.exports = __webpack_public_path__ + "static/media/snappy-selo.501b6822.svg";